import { DispositionStateModel } from '../interface/disposition.interface';

export class SetDisposition {
    static readonly type = '[Disposition] Set Disposition';

    constructor(public dispositionState: DispositionStateModel) {}
}

export class ResetDisposition {
    static readonly type = '[Disposition] Reset Disposition';
}

export class AssignOrderToSurveyorBusy {
    static readonly type = '[Disposition] Assign Order To Surveyor Busy';

    constructor(public isBusy: boolean) {}
}

export class OfferOrder {
    static readonly type = '[Disposition] Offer Order';
}

export class OfferOrderSuccess {
    static readonly type = '[Disposition] Offer Order Success';
}
